import signalr from '@/f1/service/signalr';
import uuid from 'uuid/v1';
import _ from 'lodash'

let vaild  = ["setting", "pattern", "refresh", "path", "check", "list", "backup", "restore", "download", "download_raw", "remove", "remove_raw", "pong", "status", "result", "error", "pattern.test", 'resource']
let resolveMapWS = {};

const WS = {
  Cmd(cmd = undefined, agent_id="0", body) {
    return new Promise((resolve, reject) => {
      try {
        let UUID = "";
        if(agent_id == "undefined") { resolve("") }
        else if(cmd.indexOf("_") > -1) { UUID  = `${WS.user_id}.${cmd.split("_")[0]}` }
        else if(cmd === "ping") { UUID  = `${WS.user_id}.pong` }
        else if(cmd === "start") { UUID  = `${WS.user_id}.result.bulk` }
        // else if(cmd === "start") { UUID  = `result` }
        else { UUID  = `${WS.user_id}.${cmd}` }
        // agent_id 어느 에이전트에 대한 것인지 바인딩 필요
        resolveMapWS[`${UUID}.${agent_id}`] = { resolve, reject };
        if(cmd == 'start') { console.log(cmd, new Date()) }
        // location.hostname == "localhost" ? console.log("request", "cmd", `${cmd}.${agent_id}` ) : '';
        return signalr.invoke('wsfinder', { app_id: 'wsfinder', cmd : `${cmd}.${agent_id}`,  body : body });
      } catch (e) { console.log(e); reject(e) }
    });
  },
  Request(cmd = undefined, agent_id="0") {
    return new Promise((resolve, reject) => {
      try {
        let UUID = "";
        if(agent_id == "undefined") { resolve("") }
        else if(cmd.indexOf("_") > -1) { UUID  = `${WS.user_id}.${cmd.split("_")[0]}` }
        else if(cmd === "ping") { UUID  = `${WS.user_id}.pong` }
        // else if(cmd === "start") { UUID  = `${WS.user_id}.result` }
        else { UUID  = `${WS.user_id}.${cmd}` }
        // agent_id 어느 에이전트에 대한 것인지 바인딩 필요
        if(cmd != 'start') {
          resolveMapWS[`${UUID}.${agent_id}`] = { resolve, reject };
        }
        // if(cmd == 'start') { console.log(cmd, new Date()) }
        // location.hostname == "localhost" ? console.log("request", "cmd", `${cmd}.${agent_id}` ) : '';
      } catch (e) { console.log(e); reject(e) }
    });
  },
  user_id : `ws.${uuid()}`
}


signalr.subscribe('wsfinder', (response) => {
  try {
    if(!response || !response.cmd) { return; }

    // console.log(response)

    try { if(response.cmd != "pong" && response.cmd != "resource") { response.body = typeof response.body == typeof "string" ? JSON.parse(response.body) : response.body; } }
    catch(e) {
      console.log(e, response)
      console.log("parser error or from data mq version");
      return;
    }
    if(response.cmd != 'list' && (!response || response.body == null)) { console.log("result null or error"); return; }
    // console.log(response, 'response', response.cmd)
    // agent_id 어느 에이전트에 대한 것인지 바인딩 필요

    let cmd = `${WS.user_id}.${response.cmd}.${response.agent_id}`;

    if(_.filter(vaild, x => response.cmd.indexOf(x) > -1).length < 1) {
      console.log("check cmd", response.cmd, new Date());
      return
    }
    // if(vaild.indexOf(response.cmd) === -1) { console.log("check cmd", cmd, new Date()); return; }
    if(resolveMapWS[cmd]) {
      // location.hostname == "localhost" ? console.log("response ws", "cmd", `${response.cmd}`, response.agent_id) : '';
      resolveMapWS[cmd].resolve(response);
      delete resolveMapWS[cmd];
      // console.log('resolved', cmd)
      return
    }

    // else {
    //   console.log('wsfinder_response toss', response)
    //   signalr.publish('wsfinder_response', response)
    // }
    if(response.cmd == 'pong' || response.cmd == 'status') {
      return;
    }

    // console.log('not me', response)
    signalr.publish('wsfinder_response', response)
  } catch (e) { console.log(e) }
});


export default {
  ws : WS,
}
